<ion-header>
  <ion-toolbar>
    <ion-title>Notification</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onUserNotificationClose()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <!-- cns: have to enclose card in item-item to be able to select text -->
  <ion-card [className]="userNotification.NotificationType">
    <ion-icon name="alert-circle"></ion-icon>    
    <ion-icon name="checkmark-circle"></ion-icon>
    <ion-icon name="close-circle"></ion-icon>
    <ion-card-header>
      <ion-card-title>{{ userNotification.Title }}</ion-card-title>
      <ion-card-subtitle>{{ userNotification.SubTitle }}</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      {{ userNotification.Notification }}
    </ion-card-content>
  </ion-card>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="onUserNotificationClose()">OK</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
